<template>
    <div id="container" type="vdpp">
        <div class="page page-dsp" v-ga:request="{pageType:'vdsp', state: {}}" v-ga:page="{pageType:'vdsp', glb: glb, state: {}}">
            <mvtHeader :geoInfo="dsp.geo"></mvtHeader>
            <div class="layout">
                <section>
                    <mvtBreadcrumb :geo="dsp.geo" ></mvtBreadcrumb>
                </section>
                <section class="grid xs-grid-cols-1 sm-grid-cols-2">
                    <div>
                        <div>
                            <div class="panel">
                                <dspTitle></dspTitle>
                            </div>
                        </div>
                        <div>
                            <div class="panel">
                                <dspRecord></dspRecord>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div class="panel">
                                <dspMap></dspMap>
                            </div>
                        </div>
                    </div>
                </section>
                <section v-if="dsp.tests && dsp.tests.length">
                    <div class = "panel">
                        <dspScore></dspScore>
                    </div>
                </section>

                <section v-if="dsp.reviews && dsp.reviews.length">
                    <div class="panel">
                        <dspReview :reviewUrl="greatSchoolReviewUrl()" />
                    </div>
                </section>
                <dspNearbySchool id="schools"></dspNearbySchool>
                <dspMarket></dspMarket>
                <section v-if="dsp.assignHomes && dsp.assignHomes.length">
                    <div class="panel">
                        <h2 class="h3 text-bold">
                            Properties Assigned to {{dsp.name}}
                        </h2>
                        <mvtLazyload data-role="propertycard">
                            <mvtListProperty :data="dsp.assignHomes"></mvtListProperty>
                        </mvtLazyload>
                    </div>
                </section>
                <section v-if="getShowList('new', 'city')">
                    <div class="panel">
                        <h2 class="h3 text-bold">
                            New Listings
                        </h2>
                        <mvtLazyload ref="lazyloadNew" data-role="propertycard">
                            <mvtNearby type="city" filterPath="/new-7/pagesize-10/" @completed="completedNew" carousalType="new"></mvtNearby>
                        </mvtLazyload>
                    </div>
                </section>
                <section v-if="getShowList('open', 'city')">
                    <div class="panel">
                        <h2 class="h3 text-bold">
                            Open Houses
                        </h2>
                        <mvtLazyload ref="lazyloadOpen" data-role="propertycard">
                            <mvtNearby type="city" filterPath="/open-houses/pagesize-10/" @completed="completedOpen" carousalType="open_house"></mvtNearby>
                        </mvtLazyload>
                    </div>
                </section>
                <section v-if="hasSeoLinks">
                    <div class="panel">
                        <h2 class="h4">{{molang('search.common.nearbyRealEstate')}}</h2>
                        <mvtSeoLink :cities="dsp.seoNearbyCities" :zipcodes="dsp.seoNearbyZipCode" :neighborhoods="dsp.seoNearbyneighborhood" :counties="dsp.seoNearbyCounties" />
                    </div>
                </section>
            </div>
            <mvtFooter :geoInfo="dsp.geo" />
        </div>
        <mvtPopSignin />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-dsp.js"></script>

<style lang="scss">
@use "./page-dsp.scss" as *;
</style>